import React from 'react';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { Button } from 'antd';

export const COLLAPSE_LIST_LABEL = 'Hide the integration list';
export const EXPAND_LIST_LABEL = 'Show the integration list';

export type IntegrationListToggleProps = {
  readonly collapsed: boolean;
  readonly onToggle: () => void;
};

export const IntegrationListToggle = ({ collapsed, onToggle }: IntegrationListToggleProps) => (
  <Button
    aria-label={collapsed ? EXPAND_LIST_LABEL : COLLAPSE_LIST_LABEL}
    aria-expanded={!collapsed}
    icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
    onClick={onToggle}
  />
);
